import {
  EnhancedTableHeader,
  EnhancedTableHeaderType
} from '@components/table/widgets/shared-with-old';
import { MAIN_THEME } from '@styles';

export const premiumDetailsHeaders = (
  currencySymbol?: string,
  isGroupMedical = false,
  isCertificate = false,
  isEndorsment = false
): Record<string, EnhancedTableHeader> => {
  if (isGroupMedical && !isCertificate) {
    const headers: Record<string, EnhancedTableHeader> = {
      insured: {
        name: 'insured',
        title: 'Insured',
        type: EnhancedTableHeaderType.Text,
        filterField: 'insured'
      },
      numberOfAdherent: {
        name: 'numberOfAdherent',
        title: 'Number of Adherent',
        type: EnhancedTableHeaderType.Text
      },
      class: {
        name: 'class',
        title: 'Class',
        type: EnhancedTableHeaderType.Text
      },
      level: {
        name: 'level',
        title: 'Level',
        type: EnhancedTableHeaderType.Text
      },
      coNssf: {
        name: 'coNssf',
        title: 'Co-NSSF',
        type: EnhancedTableHeaderType.Text
      },
      sumInsured: {
        name: 'sumInsured',
        title: 'Sum Insured',
        type: EnhancedTableHeaderType.RoundedCurrency,
        currency: currencySymbol
      },
      netPremium: {
        name: 'netPremium',
        title: 'Net Premium',
        type: EnhancedTableHeaderType.RoundedCurrency,
        currency: currencySymbol
      },
      charges: {
        name: 'charges',
        title: 'Charges',
        type: EnhancedTableHeaderType.RoundedCurrency,
        currency: currencySymbol
      },
      tpaFees: {
        name: 'tpaFees',
        title: 'TPA Fees',
        type: EnhancedTableHeaderType.RoundedCurrency,
        currency: currencySymbol
      },
      grossPremium: {
        name: 'grossPremium',
        title: 'Gross Premium',
        type: EnhancedTableHeaderType.RoundedCurrency,
        currency: currencySymbol
      },
      proportionalStamp: {
        name: 'proportionalStamp',
        title: 'Prop Stamp',
        type: EnhancedTableHeaderType.RoundedCurrency,
        currency: currencySymbol
      },
      municipalityTax: {
        name: 'municipalityTax',
        title: 'Mun Tax',
        type: EnhancedTableHeaderType.RoundedCurrency,
        currency: currencySymbol
      },
      totalPremium: {
        name: 'totalPremium',
        title: 'Total Premium',
        type: EnhancedTableHeaderType.RoundedCurrency,
        currency: currencySymbol
      }
    };

    return headers;
  }

  // Default (non-group medical)
  const headers: Record<string, EnhancedTableHeader> = {
    insured: {
      name: 'insured',
      title: 'Insured',
      type: EnhancedTableHeaderType.Text,
      filterField: 'policyPerson.person.fullName'
    },
    relation: {
      name: 'relation',
      title: 'Relation',
      type: EnhancedTableHeaderType.Text,
      filterField: 'policyPerson.relation'
    },
    age: {
      name: 'age',
      title: 'Age',
      type: EnhancedTableHeaderType.Text
    },
    sumInsured: {
      name: 'sumInsured',
      title: 'Sum Insured',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currencySymbol
    },
    netPremium: {
      name: 'netPremium',
      title: 'Net Premium',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currencySymbol
    },
    charges: {
      name: 'charges',
      title: 'Charges',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currencySymbol
    },
    tpaFees: {
      name: 'tpaFees',
      title: 'TPA Fees',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currencySymbol
    },
    grossPremium: {
      name: 'grossPremium',
      title: 'Gross Premium',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currencySymbol
    },
    proportionalStamps: {
      name: 'proportionalStamps',
      title: 'Prop Stamp',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currencySymbol
    },
    municipalityTax: {
      name: 'municipalityTax',
      title: 'Mun Tax',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currencySymbol
    },
    totalPremium: {
      name: 'totalPremium',
      title: 'Total Premium',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currencySymbol
    }
  };
  if (isEndorsment) {
    headers.state = {
      name: 'state',
      title: 'State',
      disableSort: true,
      type: EnhancedTableHeaderType.ColoredText,
      textColorConfig: {
        'Early Leaver': MAIN_THEME.color.red,
        'New Joiner': MAIN_THEME.color.green
      }
    };
  }

  return headers;
};
